import styled from 'styled-components'
import {Container} from '../Common/Common.style'

export const AboutContainer = styled(Container)`

`



// WEBPACK FOOTER //
// ./src/About/About.style.js